module.exports = __webpack_public_path__ + "static/media/blog11.0ffb2dc8.webp";